module.exports = __webpack_public_path__ + "static/img/hzhb11.bcd0972.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hzhb11.png
// module id = v6PO
// module chunks = 0